import { Link } from 'react-router-dom';
import type { CatalogProduct } from '@/mocks/products';

export default function ProductCard({ product }: { product: CatalogProduct }) {
  return (
    <Link to={`/products/${product.slug}`} className="group flex flex-col cursor-pointer focus-visible:outline-none">
      <div className="r-img w-full aspect-square bg-background-100/60 flex items-center justify-center p-6 overflow-hidden group-focus-visible:ring-2 group-focus-visible:ring-primary-400">
        <img
          src={product.image}
          alt={`${product.name} - ${product.family}`}
          title={`${product.name} - NORTHLINE ${product.family}`}
          className="max-w-full max-h-full object-contain object-center transition-transform duration-700 group-hover:scale-[1.04]"
        />
      </div>
      <p className="mt-5 font-label text-[11px] tracking-[0.12em] uppercase text-foreground-500">{product.family}</p>
      <h3 className="mt-1.5 text-base md:text-lg font-heading text-foreground-950 group-hover:text-primary-500 transition-colors">{product.name}</h3>
      <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{product.description}</p>
      <span className="mt-4 inline-flex items-center gap-2 text-sm text-foreground-950 group-hover:text-primary-500 transition-colors whitespace-nowrap">
        View Details <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
      </span>
    </Link>
  );
}